<template>
    <div class="project-sample">
        <div class="icon">
            <img :src="util$.formatUrlWithToken$(data.icon || data.screenshot)" alt="">
        </div>
        <div class="right">
            <h4 v-row-limit="1" class="sample-title">{{util$.getI18nLabel$(data.i18n, "langCode", "name") || data.name}}</h4>
            <p v-row-limit="2" class="sample-desc">{{util$.getI18nLabel$(data.i18n, "langCode", "description")}}</p>
        </div>
    </div>
</template>
<script>
import rowLimit from "@/code-lab/directives/row-limit.vue"
export default {
    name: "project-sample",
    props: {
        data: Object
    },
    directives: {
        rowLimit
    }
}
</script>
<style lang="scss">
.project-sample{
    width: 100%;
    height: 100%;
    display: flex;
    border-radius: 8px;
    overflow: hidden;
    justify-content: space-between;
    align-items: center;
    background: #333333;
    &:hover{
        box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.3);
        background-color: #696969;
    }
    .icon{
        width: 74px;
        height: 60px;
        flex: 0 0 auto;
        text-align: right;
        img{
            width: 60px;
            height: 60px;
        }
    }
    .right{
        width: 100%;
        height: 100%;
        padding: 8px 14px;
        flex: 1 1 auto;
        .sample-title{
            height: 28px;
            padding: 0;
            line-height: 28px;
            font-size: 14px;
            font-weight: bold;
            color: #ffffff;
        }
        .sample-desc{
            width: 100%;
            height: calc(100% - 32px);
            padding: 0;
            color: #c8c8c8;
            font-size: 12px;
            line-height: 18px;
        }

    }
}
</style>